import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import pages from '@/lib/publicSeo.json';

export default function PublicSeo() {
  const { pathname } = useLocation();
  const route = pathname.replace(/\/+$/, '') || '/';
  const page = pages[route];
  // These pages own their Helmet metadata. React 19 hoists each owner's tags
  // independently, so a fallback here would create a competing title.
  const pageOwnsMetadata = ['/terms', '/privacy', '/responsible-play', '/live'].includes(route);
  if (route.startsWith('/sports/') || pageOwnsMetadata) return null;
  return (
    <Helmet>
      <title>{page?.title || 'Parlay Posse'}</title>
      {page && <meta name="description" content={page.description} />}
      {page && <link rel="canonical" href={`https://www.parlayposse.com${route}`} />}
      {page && <meta property="og:title" content={page.title} />}
      {page && <meta property="og:description" content={page.description} />}
      {page && <meta property="og:url" content={`https://www.parlayposse.com${route}`} />}
      {page && <meta name="twitter:title" content={page.title} />}
      {page && <meta name="twitter:description" content={page.description} />}
    </Helmet>
  );
}
